export const DISMISS_ANNOUNCEMENT_BANNER = 'dismiss-announcement-banner';
const dismissAnnouncementBanner = () => ({ type: DISMISS_ANNOUNCEMENT_BANNER });
export default dismissAnnouncementBanner;
